import {
  Divider,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import {t} from 'i18next';
import {ReactElement, useState} from 'react';
import AurPopup from '../../../common/aur-popup/AurPopup';
import {STRStatusType} from '../hook/useSTRStatus';

interface STRBulkTaggingModalProps {
  status: STRStatusType | null;
  visible: boolean;
  onClose: () => void;
  onConfirmTagging: (visible: boolean, value: string) => void;
}

interface LabelProps {
  header: string;
  subHeader: string;
}

interface FormContent extends LabelProps {
  value: string;
  disabled?: boolean;
  key: string;
}

const STRBulkTaggingModal = (props: STRBulkTaggingModalProps) => {
  const {status, visible, onClose, onConfirmTagging} = props;
  const stringPath = 'eca.searchTermReport.viewSTR.bulkTaggingModal.';
  const formContent: FormContent[] = [
    {
      header: t(stringPath + 'formContent.label1.header'),
      subHeader: t(stringPath + 'formContent.label1.subHeader'),
      value: t(stringPath + 'formContent.label1.value'),
      key: 'tagging-field-one',
    },
    {
      header: t(stringPath + 'formContent.label2.header'),
      subHeader: t(stringPath + 'formContent.label2.subHeader'),
      value: t(stringPath + 'formContent.label2.value'),
      key: 'tagging-field-two',
    },
    {
      header: t(stringPath + 'formContent.label3.header'),
      subHeader: t(stringPath + 'formContent.label3.subHeader'),
      value: t(stringPath + 'formContent.label3.value'),
      disabled: status === STRStatusType.InProgress,
      key: 'tagging-field-three',
    },
  ];

  const [selectedValue, setSelectedValue] = useState<string>('');

  const handleOk = () => {
    setSelectedValue('');
    onConfirmTagging(true, selectedValue);
  };

  const handleCancel = () => {
    setSelectedValue('');
    onClose();
  };

  const radioIcon = (isSelected: boolean) => {
    if (isSelected) return '/assests/images/radio-checked.svg';
    return '/assests/images/radio-unchecked.svg';
  };

  const renderLabel = (props: LabelProps) => {
    const {header, subHeader} = props;
    return (
      <div className="label-text-container">
        <Typography className="typo-text subhead3_size heading-text">
          {header}
        </Typography>
        <Typography className="typo-text body3_size body-text">
          {subHeader}
        </Typography>
      </div>
    );
  };

  const renderModalContent = (): ReactElement => {
    return (
      <FormControl className="str-bulk-tagging-modal">
        <Typography className="typo-text body2_size body-text">
          {t(stringPath + 'formHeader')}
        </Typography>
        <RadioGroup
          className="radio-group"
          value={selectedValue}
          onChange={(e) => setSelectedValue(e.target.value)}
        >
          {formContent.map((item, index) => {
            return (
              <>
                <FormControlLabel
                  className="form-control-label"
                  value={item.value}
                  control={
                    <Radio
                      className="radio-button"
                      checkedIcon={
                        <img
                          src={radioIcon(item.value === selectedValue)}
                          alt=""
                        />
                      }
                    />
                  }
                  label={renderLabel({
                    header: item.header,
                    subHeader: item.subHeader,
                  })}
                  key={item.key}
                  disabled={item?.disabled}
                />
                {index < formContent.length - 1 && (
                  <Divider
                    orientation="horizontal"
                    variant="middle"
                    flexItem
                    className="horizontal-divider"
                  />
                )}
              </>
            );
          })}
        </RadioGroup>
      </FormControl>
    );
  };
  return (
    <AurPopup
      onOk={handleOk}
      onCancel={handleCancel}
      open={visible}
      showPopupTitle={true}
      popupTitle={t(stringPath + 'popupTitle')}
      showCloseIcon={true}
      showPopupHeading={true}
      popupHeading={t(stringPath + 'popupHeading')}
      contentType="element"
      popupContent={renderModalContent()}
      labelActionCancel={t('buttons.cancel')}
      labelActionOk={t(stringPath + 'labelActionOk')}
      continueButtonState={!selectedValue}
      className="create-str-modal aur-unsaved-changes-popup"
    />
  );
};

export default STRBulkTaggingModal;
